module.exports = __webpack_public_path__ + "static/media/credit-card-selected.4c73816f.svg";